module.exports = __webpack_public_path__ + "img/2025-pass.7fe9c215.svg";